<img ngSrc="assets/images/logo-acciona.webp" fill priority="high" alt="{{'GENERAL.LOGO'|translate}}"/>
